import React from 'react'
import lazyLoad from '@utils/lazyLoad'
import { setApplicationCode } from '@utils/utils'
import applicationCode from '@enum/applicationCode'
import Stage1Landing from '@components/Layouts/Stage1Landing'

const cdpRoutes = [
  // {
  //   path: '/CDP/Kanban/Customer',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/CDP/BasicManage/MeterManage'))
  // },
  {
    path: '/CDP/Kanban/Customer',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/Kanban/Customer/index')),
    meta: {
      title: '客户看板',
      layoutMode: 'empty'
    }
  },
  {
    path: '/CDP/Kanban/Member',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/Kanban/Member/index')),
    meta: {
      title: '会员看板',
      layoutMode: 'empty'
    }
  },
  {
    path: '/User/CustomerGroupAnalysis',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/CustomerGroupAnalysis/index')),
    meta: {
      title: '客群分析',
      layoutMode: 'empty'
    }
  },
  {
    path: '/CDP/Kanban/Channel',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/Kanban/Channel/index')),
    meta: {
      title: '渠道看板',
      layoutMode: 'empty'
    }
  },
  {
    path: '/CDP/Kanban/Commodity',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/Kanban/Commodity/index')),
    meta: {
      title: '商品看板',
      layoutMode: 'empty'
    }
  },
  {
    path: '/CDP/Kanban/Order',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/Kanban/Order/index')),
    meta: {
      title: '订单看板',
      layoutMode: 'empty'
    }
  },
  {
    path: '/CDP/Kanban/MarketingConversion',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/Kanban/MarketingConversion')),
    meta: {
      title: '营销转化',
      layoutMode: 'empty'
    }
  },
  // 分析
  {
    path: '/CDP/anaylsis/activity_overview',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/Analysis/ActivityAnalysis')),
    meta: {
      title: '活动分析',
      layoutMode: 'empty'
    }
  },
  {
    path: '/Meter/ShowMeter/:id', // 仪表盘查看仪表盘
    exact: true,
    component: lazyLoad(() => import('@views/CDP/Meter/ShowMeter')),
    meta: {
      title: '仪表盘详情',
      layoutMode: 'empty',
      hideCrumb: true
    }
  },
  {
    path: '/Meter/EditMeter/:id', // 仪表盘查看仪表盘
    exact: true,
    meta: {
      title: '仪表盘详情',
      layoutMode: 'empty'
    },
    component: lazyLoad(() => import('@views/CDP/Meter/ShowMeter'))
  },
  {
    path: '/UserAnalysis/EventAnalysis', // 用户分析 事件分析
    exact: true,
    component: lazyLoad(() => import('@views/CDP/UserAnalysis/EventAnalysis'))
  },
  {
    path: '/UserAnalysis/EventAnalysis/new', // 用户分析 新建事件分析
    exact: true,
    meta: {
      title: '图表新建'
    },
    component: lazyLoad(() =>
      import('@views/CDP/UserAnalysis/EventAnalysis/new')
    )
  },
  {
    path: '/UserAnalysis/EventAnalysis/:id', // 用户分析 编辑事件分析
    exact: true,
    meta: {
      title: '图表详情'
    },
    component: lazyLoad(() => import('@views/CDP/UserAnalysis/EventAnalysis'))
  },
  {
    path: '/UserAnalysis/EventAnalysis/:id/:dashboard', // 用户分析 编辑事件分析
    exact: true,
    meta: {
      title: '图表详情'
    },
    component: lazyLoad(() => import('@views/CDP/UserAnalysis/EventAnalysis'))
  },
  {
    path: '/UserAnalysis/FunnelAnalysis', // 用户分析 漏斗分析
    exact: true,
    component: lazyLoad(() => import('@views/CDP/UserAnalysis/FunnelAnalysis'))
  },
  {
    path: '/UserAnalysis/FunnelAnalysis/new', // 用户分析 漏斗分析新建
    exact: true,
    meta: {
      title: '图表新建'
    },
    component: lazyLoad(() =>
      import('@views/CDP/UserAnalysis/FunnelAnalysis/new')
    )
  },
  {
    path: '/UserAnalysis/FunnelAnalysis/:id', // 用户分析 编辑漏斗分析
    exact: true,
    meta: {
      title: '图表详情'
    },
    component: lazyLoad(() => import('@views/CDP/UserAnalysis/FunnelAnalysis'))
  },
  {
    path: '/UserAnalysis/FunnelAnalysis/:id/:dashboard', // 用户分析 编辑漏斗分析
    exact: true,
    meta: {
      title: '图表详情'
    },
    component: lazyLoad(() => import('@views/CDP/UserAnalysis/FunnelAnalysis'))
  },
  {
    path: '/UserAnalysis/AttributeAnalysis', // 用户分析 属性分析
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/UserAnalysis/AttributeAnalysis')
    )
  },
  {
    path: '/UserAnalysis/AttributeAnalysis/new', // 用户分析 属性分析新建
    exact: true,
    meta: {
      title: '图表新建'
    },
    component: lazyLoad(() =>
      import('@views/CDP/UserAnalysis/AttributeAnalysis/new')
    )
  },
  {
    path: '/UserAnalysis/AttributeAnalysis/:id', // 用户分析 编辑属性分析
    exact: true,
    meta: {
      title: '图表详情'
    },
    component: lazyLoad(() =>
      import('@views/CDP/UserAnalysis/AttributeAnalysis')
    )
  },
  {
    path: '/UserAnalysis/AttributeAnalysis/:id/:dashboard', // 用户分析 编辑属性分析
    exact: true,
    meta: {
      title: '图表详情'
    },
    component: lazyLoad(() =>
      import('@views/CDP/UserAnalysis/AttributeAnalysis')
    )
  },
  {
    path: '/UserAnalysis/MarketingEffect', // 用户分析 营销活动分析
    exact: true,
    component: lazyLoad(() => import('@views/CDP/UserAnalysis/MarketingEffect'))
  },
  {
    path: '/UserAnalysis/MarketingEffect/new', // 用户分析 营销活动分析新建
    exact: true,
    meta: {
      title: '图表新建'
    },
    component: lazyLoad(() =>
      import('@views/CDP/UserAnalysis/MarketingEffect/new')
    )
  },
  {
    path: '/UserAnalysis/MarketingEffect/:id', // 用户分析 编辑营销活动分析
    exact: true,
    meta: {
      title: '图表详情'
    },
    component: lazyLoad(() => import('@views/CDP/UserAnalysis/MarketingEffect'))
  },
  {
    path: '/UserAnalysis/MarketingEffect/:id/:dashboard', // 用户分析 编辑营销活动分析
    exact: true,
    meta: {
      title: '图表详情'
    },
    component: lazyLoad(() => import('@views/CDP/UserAnalysis/MarketingEffect'))
  },
  // AIPL 模型
  {
    path: '/ModelPanel/APIL',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/ModelPanel/AIPL')),
    meta: {
      layoutMode: 'empty'
    }
  },
  // 事件统计
  {
    path: '/Events/Statistics',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/EventMangent/Statistics')),
    meta: {
      layoutMode: 'empty'
    }
  },
  // 事件统计
  {
    path: '/Events/Statistics/:eventCode',
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/EventMangent/StatisticsDetail')
    ),
    meta: {
      layoutMode: 'empty',
      title: '事件分析'
    }
  },
  {
    path: '/setting/custom/manage/event',
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/EventMangent/CustimizeEventManage')
    )
  },
  {
    path: '/setting/custom/manage/attr/new',
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/EventMangent/CustimizeEventManage/AttrDetail')
    ),
    meta: {
      title: '新建自定义属性'
    }
  },
  {
    path: '/setting/custom/manage/attr/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/EventMangent/CustimizeEventManage/AttrDetail')
    ),
    meta: {
      title: '自定义属性编辑'
    }
  },
  {
    path: '/setting/custom/manage/event/new',
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/EventMangent/CustimizeEventManage/EventDetail')
    ),
    meta: {
      title: '新建自定义事件'
    }
  },
  {
    path: '/setting/custom/manage/event/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/EventMangent/CustimizeEventManage/EventDetail')
    ),
    meta: {
      title: '自定义事件编辑'
    }
  },
  {
    path: '/IndicatorAnalysis/IndicatorManage', // 指标分析 指标管理
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/IndicatorAnalysis/IndicatorManage')
    )
  },
  {
    path: '/IndicatorAnalysis/CreateIndicator', // 指标分析 创建指标
    exact: true,
    meta: {
      title: '指标创建'
    },
    component: lazyLoad(() =>
      import('@views/CDP/IndicatorAnalysis/EditIndicator')
    )
  },
  {
    path: '/IndicatorAnalysis/EditIndicator/:id', // 指标分析 编辑指标
    exact: true,
    meta: {
      title: '指标配置'
    },
    component: lazyLoad(() =>
      import('@views/CDP/IndicatorAnalysis/EditIndicator')
    )
  },
  {
    path: '/IndicatorAnalysis/EditIndicator/:id/:dashboard', // 指标分析 编辑指标
    exact: true,
    meta: {
      title: '指标配置'
    },
    component: lazyLoad(() =>
      import('@views/CDP/IndicatorAnalysis/EditIndicator')
    )
  },
  {
    path: '/IndicatorAnalysis/IndicatorDetail/:id', // 指标分析 指标详情
    exact: true,
    meta: {
      title: '指标详情'
    },
    component: lazyLoad(() =>
      import('@views/CDP/IndicatorAnalysis/IndicatorDetail')
    )
  },
  {
    path: '/IndicatorAnalysis/IndicatorDecomposition', // 指标分析 指标演绎
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/IndicatorAnalysis/IndicatorDecomposition')
    )
  },
  {
    path: '/CustomerPersonaProfile/List', // 客户画像
    exact: true,
    component: lazyLoad(() => import('@views/CDP/CustomerPersonaProfile/List'))
  },
  {
    path: '/CustomerPersonaProfile/Detail/:id', // 客户洞察 客户档案
    exact: true,
    meta: {
      title: '客户详情'
    },
    component: lazyLoad(() =>
      import('@views/CDP/CustomerPersonaProfile/Detail')
    )
  },
  {
    path: '/CustomerGroupProfile/TemplateList', // 客群画像模板
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/CustomerGroupProfile/TemplateList')
    ),
    meta: {
      title: '客群画像模板'
    }
  },
  {
    path: '/CustomerGroupProfile/Home', // 自定义客群画像
    exact: true,
    component: lazyLoad(() => import('@views/CDP/CustomerGroupProfile/Home')),
    meta: {
      title: '自定义客群画像',
      layoutMode: 'empty'
    }
  },
  {
    path: '/CustomerGroupProfile/TemplateList/:id', // 客群画像模板详情
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/CustomerGroupProfile/TemplateDetail')
    ),
    meta: {
      title: '模板详情',
      layoutMode: 'empty'
    }
  },
  {
    path: '/yx/automateTagList', // 标签管理  标签体系
    exact: true,
    component: lazyLoad(() => import('@views/TagSystem/list'))
  },
  {
    path: '/yx/automateTagList/detail/:id', // 标签值详情
    exact: true,
    component: lazyLoad(() => import('@views/TagSystem/detail')),
    meta: {
      title: '标签值详情'
    }
  },
  {
    path: '/yx/automateTagList/create', // 标签值创建
    exact: true,
    component: lazyLoad(() => import('@views/TagSystem/create'))
  },
  {
    path: '/yx/automateTagList/edit', // 标签值修改
    exact: true,
    component: lazyLoad(() => import('@views/TagSystem/create'))
  },
  {
    path: '/LabelManage/LabelSort/CreateLabelSort', // 标签管理  标签分类 创建标签分类
    exact: true,
    component: lazyLoad(() =>
      import(
        '@views/CDP/LabelSystem/CustomerLabelManage/LabelSort/CreateLabelSort'
      )
    )
  },
  {
    path: '/LabelManage/LabelSort/EditLabelSort', // 标签管理  标签分类 编辑标签分类
    exact: true,
    component: lazyLoad(() =>
      import(
        '@views/CDP/LabelSystem/CustomerLabelManage/LabelSort/EditLabelSort'
      )
    )
  },
  {
    path: '/LabelManage/LabelSort/DeleteLabelSort', // 标签管理  标签分类 删除包含子集分类
    exact: true,
    component: lazyLoad(() =>
      import(
        '@views/CDP/LabelSystem/CustomerLabelManage/LabelSort/DeleteLabelSort'
      )
    )
  },
  {
    path: '/LabelManage/LabelSort/DeleteNullSort', // 标签管理  标签分类 删除空分类
    exact: true,
    component: lazyLoad(() =>
      import(
        '@views/CDP/LabelSystem/CustomerLabelManage/LabelSort/DeleteNullSort'
      )
    )
  },
  {
    path: '/LabelManage/Label/NewLabel', // 标签管理  标签 创建标签
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/LabelSystem/CustomerLabelManage/Label/NewLabel')
    )
  },
  {
    path: '/LabelManage/Label/GatherLabel', // 标签管理  标签 标签集合
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/LabelSystem/CustomerLabelManage/Label/GatherLabels')
    )
  },
  {
    path: '/LabelManage/Label/StringLabel', // 标签管理  标签 标签字符
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/LabelSystem/CustomerLabelManage/Label/StringLabel')
    )
  },
  {
    path: '/LabelManage/Label/NumberLabel', // 标签管理  标签 标签数值
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/LabelSystem/CustomerLabelManage/Label/NumberLabel')
    )
  },
  {
    path: '/LabelManage/Label/DateLabel', // 标签管理  标签 标签日期
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/LabelSystem/CustomerLabelManage/Label/DateLabel')
    )
  },
  {
    path: '/LabelManage/Label/BoolLabel', // 标签管理  标签 标签布尔
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/LabelSystem/CustomerLabelManage/Label/BoolLabel')
    )
  },
  {
    path: '/LabelManage/Label/ListLabel', // 标签管理  标签 标签列表
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/LabelSystem/CustomerLabelManage/Label/ListLabel')
    )
  },
  {
    path: '/CDP/CommdityLabelManage', // 标签管理  商品标签 标签列表
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/LabelSystem/CommodityLabelManage/List')
    ),
    meta: {
      layoutMode: 'empty'
    }
  },
  {
    path: '/BasicManage/MeterManage', // 基础管理 仪表盘管理
    exact: true,
    component: lazyLoad(() => import('@views/CDP/BasicManage/MeterManage'))
  },
  {
    path: '/product/product', // 基础管理 数据管理
    exact: true,
    component: lazyLoad(() => import('@views/CDP/BasicManage/DataManage'))
  },
  {
    path: '/CDP/import', // 基础管理 数据管理
    exact: true,
    component: lazyLoad(() => import('@views/CDP/BasicManage/DataImport'))
  },
  {
    path: '/CDP/workspace',
    exact: true,
    component: Stage1Landing,
    meta: { title: '数据工作台', layoutMode: 'stage1' }
  },
  {
    path: '/CDP/data-sources',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/DataSources')),
    meta: {
      title: '数据源管理',
      layoutMode: 'stage1'
    }
  },
  {
    path: '/CDP/metadata',
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/DataAssets').then(module => ({
        default: module.AuthorizedMetadataPage
      }))
    ),
    meta: { title: '元数据目录', layoutMode: 'stage1' }
  },
  {
    path: '/CDP/entities',
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/DataAssets').then(module => ({
        default: module.AuthorizedEntitiesPage
      }))
    ),
    meta: { title: '实体与字段', layoutMode: 'stage1' }
  },
  {
    path: '/CDP/feature-dictionary',
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/DataAssets').then(module => ({
        default: module.AuthorizedFeatureDictionaryPage
      }))
    ),
    meta: { title: '基础特征字典', layoutMode: 'stage1' }
  },
  {
    path: '/CDP/batch',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/Batch')),
    meta: { title: '仓内批任务', layoutMode: 'stage1' }
  },
  {
    path: '/CDP/runtime',
    exact: true,
    // Old monitor bookmarks follow the same permission-scoped landing as the retired overview.
    component: Stage1Landing,
    meta: { title: '数据接入与运行', layoutMode: 'stage1' }
  },
  {
    path: '/CDP/quality',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/Quality')),
    meta: { title: '数据质量检查', layoutMode: 'stage1' }
  },
  {
    path: '/CDP/privacy',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/Privacy')),
    meta: { title: '字段隐私与脱敏预览', layoutMode: 'stage1' }
  },
  {
    path: '/CDP/tag-batch',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/TagAssets')),
    meta: { title: '标签批处理', layoutMode: 'stage1' }
  },
  {
    path: '/CDP/customer-context',
    exact: true,
    component: lazyLoad(() => import('@views/CDP/CustomerContext')),
    meta: { title: '客户关联视图', layoutMode: 'stage1' }
  },
  {
    path: '/CDP/ModelPanel/RFMModal', // 模型管理 RFM模型 RFM模型详情
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/ModelPanel/RFMModal/RfmModal')
    ),
    meta: {
      applicationCode: '52ac6eba-064d-4bcc-9e46-d3f42dfeb7fa',
      title: 'RFM',
      layoutMode: 'empty'
    }
  },
  {
    path: '/CDP/ModelPanel/FunnelModal', // 模型管理 漏斗模型 漏斗模型详情
    exact: true,
    component: lazyLoad(() =>
      import('@views/CDP/ModelPanel/FunnelModal/FunnelModal')
    ),
    meta: {
      applicationCode: '52ac6eba-064d-4bcc-9e46-d3f42dfeb7fa',
      title: '漏斗',
      layoutMode: 'empty'
    }
  }
]

export default setApplicationCode(applicationCode.cdp)(cdpRoutes)
